var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","gap":"1%"}},[_c('b-card',{staticClass:"mx-auto",staticStyle:{"flex":"1"},attrs:{"align":"center"}},[_c('rankingMetaAtual')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }